<template>
  <div class="meter-device-external-operator-statements">

    <v-row>
      <v-col cols="6">
        <template  v-if="statementUrl">
          <v-btn small target="_blank" text :href="statementUrl">
            Lien de relevé
          </v-btn>
          <v-btn  class="mr-3" small icon @click="copyToClipboard(statementUrl)"><v-icon small>mdi-content-copy</v-icon></v-btn>
        </template>
        <v-btn small @click="sendCustomerStatementsRequest" :disabled="!meterDevice.customer?.id">
          Envoyer un {{ statementUrl ?  'nouveau' : ''}} lien de relevé au client
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <v-select
            v-model="filters.status"
            :label="$t('status')"
            :items="[
              {text: $t('meter-device.reading.status.PENDING'), value: 'pending'},
              {text: $t('meter-device.reading.status.ACCEPTED'), value: 'accepted'},
              {text: $t('meter-device.reading.status.REJECTED'), value: 'rejected'},
          ]"
        ></v-select>
      </v-col>
    </v-row>

    <v-data-table
        class="mt-6"
        :headers="headers"
        :items="statements"
        :loading="loading"
        :options.sync="options"
        :server-items-length="total"
    >

      <template #item.createdAt="{ item }">
        {{ item.createdAt | formatDate($t('format_date')) }}
      </template>

      <template #item.startDate="{ item }">
        <span class="text-capitalize">
          {{ item.startDate | formatDate($t('format_month_str')) }}
        </span>
      </template>


      <template #item.energy="{ item }">
        {{ item.energy.toFixed(3) }} kWh
      </template>

      <template #item.amount="{ item }">
        {{ item.amount.toFixed(2) }} €
      </template>

      <template #item.actions="{ item }">
        <v-btn icon small @click="openReview(item)">
          <v-icon v-if="item.status === 'accepted'">mdi-eye</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <meter-device-external-operator-statement-review ref="statementReviewModal" />
  </div>
</template>

<script>
import MeterDeviceRepository from "@repository/MeterDeviceRepository";
import CustomerRepository from "@repository/CustomerRepository";
import MeterDeviceExternalOperatorStatementReview
  from "@pages/MeterDevice/Detail/modals/MeterDeviceExternalOperatorStatementReview.vue";

export default {
  components: {
    MeterDeviceExternalOperatorStatementReview,
  },
  data() {
    return {
      loading: false,
      filters: {
        status: 'pending',
      },
      options: {
        page: 1,
        sortBy: ['createdAt'],
        sortDesc: [true],
      },
      total: 0,
      statements: [],
    }
  },

  computed: {
    headers() {
      return [
        { text: this.$t('period'), value: 'startDate' },
        { text: this.$t('charging-point.consumed-energy'), value: 'energy' },
        { text: this.$t('amount'), value: 'amount' },
        { text: this.$t('created-at'), value: 'createdAt' },
        { text: "", value: 'actions', width: '150'},
      ]
    },

    meterDevice() {
      return this.$parent.meterDevice
    },

    statementUrl() {
      if(this.meterDevice?.statementToken) {
        return `${window.location.origin}/register-external-invoice?token=${this.meterDevice?.statementToken}`
      }
      return null
    }


  },

  watch: {
    filters: {
      handler() {
        this.loadData()
      },
      deep: true,
    },

    options: {
      handler() {
        this.loadData()
      },
      deep: true,
    }
  },

  mounted() {

  },

  methods: {

    loadData() {
      this.loading = true;

      let data = {
        meterDeviceId: this.meterDevice.id,
        status: this.filters.status,
      };

      if (this.options.itemsPerPage > -1) {
        data.offset = (this.options.page * this.options.itemsPerPage) - this.options.itemsPerPage
      }
      data.limit = this.options.itemsPerPage

      if (this.options.sortBy.length > 0) {
        data.orderBy = this.options.sortBy[0]
      }

      if (this.options.sortDesc.length > 0) {
        data.orderDirection = this.options.sortDesc[0] ? 'desc' : 'asc'
      }

      MeterDeviceRepository.searchExternalOperatorStatements(data).then(statements => {
            this.statements = statements.items.map(statement => {
              for(const a in statement.data) {

                const keys = Object.keys(statement.data[a])
                if(keys.includes('consumption')) {
                  statement.data[a].consumption = statement.data[a].consumption / 1000
                }
              }
              return {
                ...statement,
                amount: statement.amount,
                energy: statement.energy / 1000,
              }
            })
            this.total = statements.total
            this.loading = false;
      }).catch(err => {
        this.loading = false;
        console.log(err)
        this.notifyError(err)
      })
    },

    sendCustomerStatementsRequest() {
      if(this.statementUrl) {
        this.$dialog.confirm({title: 'Confirmation', text: "Cela désactivera l'ancien lien et enverra un nouveau lien de relevé au client.<br /><br />Voulez-vous continuer ?"}).then(result => {
          if(result) {
            this.sendCustomerStatementsRequestConfirmed()
          }
        }).catch(() => {
          // do nothing
        })
      } else {
        this.sendCustomerStatementsRequestConfirmed()
      }
    },

    sendCustomerStatementsRequestConfirmed() {
      this.showLoading(true)
      MeterDeviceRepository.sendCustomerStatementRequest(this.meterDevice.id).then(() => {
        this.notifySuccess(this.$t('meter-device.external-operator.statement-request-sent'))
        this.showLoading(false)
        this.$parent.loadData()
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    },

    openReview(statement) {
      this.$refs.statementReviewModal.open(statement, this.meterDevice)
    },

  }
}
</script>

<style lang="scss">
.meter-device-external-operator-statements {

}
</style>